import { useQuery } from '@apollo/client'
import organisationGetQuery from '@queries/organisationGetQuery'
import { Organisation } from '@typings/entities/Organisation'
import { ApiHookResult } from '@typings/ApiHooks'

export const useGetOrganisationQuery = ({ id }: { id: string }): ApiHookResult<Organisation> => {
  const { data, loading, error } = useQuery(organisationGetQuery, { variables: { id } })

  return { data: data?.organisationGet, isLoading: loading, error }
}
